import React, { Component } from 'react'
import './users.css'
import TitleBar from '../TitleBar'
import getLabel from '../../utilities/label.js'

export default class MyProfileEdit extends Component {
  constructor(props) {
    super(props)
    var user = this.getUser(window.currentUser.user_id)
    this.state = {
      email: user.email || '',
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      title: user.title || '',
      organization_name: user.organization_name || '',
      phone: user.phone || '',
      address: user.address || '',
      city: user.city || '',
      state_name: user.state || '',
      postal_code: user.postal_code || '',
      bio: user.bio || '',
      dietary_restrictions: user.dietary_restrictions || ''
    }
    this.cancel = this.cancel.bind(this)
    this.submit = this.submit.bind(this)
    this.props.setActiveTab('homepage')
    window.trackPage('ProfileEditFormScreen')
  }

  getUser(id) {
    return this.props.users.event_users.find( (user) => {
      return user.user_id === id
    })
  }

  handleUpdate(type) {
    return (e) => {
      e.preventDefault()
      this.setState({
        [type]: e.currentTarget.value
      })
    }
  }

  submit(e) {
    e.preventDefault()
    // set vars
    const {
      first_name,
      last_name,
      title,
      organization_name,
      phone,
      address,
      city,
      state_name,
      postal_code,
      bio,
      dietary_restrictions
    } = this.state
    if (!first_name) {
      return this.props.flashMessage({
        message: `${ getLabel('first_name') } ${ getLabel('asterisks_are_required') }`,
        type: 'error'
      })
    } else if (!last_name) {
      return this.props.flashMessage({
        message: `${ getLabel('last_name') } ${ getLabel('asterisks_are_required') }`,
        type: 'error'
      })
    }
    this.props.postResource({
      key: 'profile_edits',
      data: { user:
        {
        	first_name: first_name,
        	last_name: last_name,
        	title: title,
        	organization_name: organization_name,
        	phone: phone,
        	address: address,
        	city: city,
        	state: state_name,
        	postal_code: postal_code,
        	bio: bio,
          dietary_restrictions: dietary_restrictions
        }
      },
      callback: () => this.props.history.push('my_profile')
    })
  }

  cancel() {
    this.props.history.push('my_profile')
  }

  render() {
    const {
      email,
      first_name,
      last_name,
      title,
      organization_name,
      phone,
      address,
      city,
      state_name,
      postal_code,
      bio,
      dietary_restrictions
    } = this.state


    const labelStyle = {
      color: 'red',
      paddingLeft: '10px'
    }

    const nameFieldStyle = {
      borderColor: 'red',
      width: '100%',
      display: 'inline-block'
    }

    return (
      <div className='user-profile'>
        <TitleBar
          title={ getLabel('edit_profile') } />
        <form>
          <div className="form-group">
            <input
              className="form-control"
              type="email"
              value={ email }
              style={ nameFieldStyle }
              disabled={ true } />
            <br/>
            <label style={ labelStyle }>{ getLabel('cannot_be_changed') }</label>
          </div>
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder={ getLabel('first_name') }
              value={ first_name }
              style={ nameFieldStyle }
              onChange={ this.handleUpdate('first_name') } />
            <br/>
            <label style={ labelStyle }>{ getLabel('asterisks_are_required') }</label>
          </div>
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder={ getLabel('last_name') }
              value={ last_name }
              style={ nameFieldStyle }
              onChange={ this.handleUpdate('last_name') } />
            <br/>
            <label style={ labelStyle }>{ getLabel('asterisks_are_required') }</label>
          </div>
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder={ getLabel('title') }
              value={ title }
              onChange={ this.handleUpdate('title') } />
          </div>
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder={ getLabel('organization') }
              value={ organization_name }
              onChange={ this.handleUpdate('organization_name') } />
          </div>
          <div className="form-group">
            <input
              className="form-control"
              type="tel"
              placeholder={ getLabel('phone') }
              value={ phone }
              onChange={ this.handleUpdate('phone') } />
          </div>
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder={ getLabel('address') }
              value={ address }
              onChange={ this.handleUpdate('address') } />
          </div>
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder={ getLabel('city') }
              value={ city }
              onChange={ this.handleUpdate('city') } />
          </div>
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder={ getLabel('state') }
              value={ state_name }
              onChange={ this.handleUpdate('state_name') } />
          </div>
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder={ getLabel('postal_code') }
              value={ postal_code }
              onChange={ this.handleUpdate('postal_code') } />
          </div>
          <p style={{ color: 'gray', fontSize: '12px' }}>* All above fields are shared when you exchange business cards.</p>
          <div className="form-group">
            <label style={{ fontSize: '1.2em', paddingLeft: '10px' }}>Dietary Restrictions</label>
            <input
              className="form-control"
              value={ dietary_restrictions }
              onChange={ this.handleUpdate('dietary_restrictions') }
              maxLength='255' />
            <p style={{ color: 'gray', fontSize: '12px' }}>This field will not be shared with business card exchange or be viewable by other users. This information is used by event staff only.</p>
          </div>
          <div className="form-group">
            <label style={{ fontSize: '1.2em', paddingLeft: '10px' }}>{ getLabel('bio') }</label>
            <textarea
              style={{ height: '200px' }}
              className="form-control"
              value={ bio }
              onChange={ this.handleUpdate('bio') } />
          </div>
          <div className="center">
            <button
              onClick={ this.submit }
              className='submit margin-top-10'>
              { getLabel('save') }
            </button>
            <button
              className='cancel-button'
              onClick={ this.cancel } >
              { getLabel('cancel')}
            </button>
          </div>
        </form>
      </div>
    )
  }
}
